module.exports = __webpack_public_path__ + "sampension_mere_vaerd_neg.svg";